export default class Carpeta {
    constructor(nro_declaracion = '', nro_registro = '', fecha_aceptacion = '', regimen_aduanero = '', modalidad_regimen = '', modalidad_despacho = '', importador = '', declarante = '', pais_exportacion = '', aduana_ingreso = '', total_nro_facturas = '', total_nro_items = '', total_nro_bultos = '', total_peso_bruto = '', total_valor_fob = '', aduana_id = null, caja_id = null) {
        this.nro_declaracion = nro_declaracion;
        this.nro_registro = nro_registro;
        this.fecha_aceptacion = fecha_aceptacion;
        this.regimen_aduanero = regimen_aduanero;
        this.modalidad_regimen = modalidad_regimen;
        this.modalidad_despacho = modalidad_despacho;
        this.importador = importador;
        this.declarante = declarante;
        this.pais_exportacion = pais_exportacion;
        this.aduana_ingreso = aduana_ingreso;
        this.total_nro_facturas = total_nro_facturas;
        this.total_nro_items = total_nro_items;
        this.total_nro_bultos = total_nro_bultos;
        this.total_peso_bruto = total_peso_bruto;
        this.total_valor_fob = total_valor_fob;
        this.aduana_id = aduana_id;
        this.caja_id = caja_id;
    }
}